import { type ApolloCache } from '@apollo/client';

import {
  type PulseRefFragment,
  PulsesDocument,
} from '@spotify/confidence-graphql';

export const prependPulseToPulsesCache = (
  cache: ApolloCache<unknown>,
  pulse: PulseRefFragment,
): void => {
  const existing = cache.readQuery({
    query: PulsesDocument,
  }) as {
    pulses?: {
      __typename: string;
      pulses: PulseRefFragment[];
      nextPageToken?: string | null;
    };
  } | null;

  if (!existing?.pulses) return;

  cache.writeQuery({
    query: PulsesDocument,
    data: {
      pulses: {
        ...existing.pulses,
        pulses: [pulse, ...existing.pulses.pulses],
      },
    },
  });
};
